export default function validationClass(validationType) {
  return "is-".concat(validationType, "-input");
}